exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.fondo-verde {\n\tbackground-color:#029001!important;\n\tcolor:#FFFFFF;\n}\n.fondo-gris {\n\tbackground-color:#E9E9E9!important;\n}\n", ""]);

// exports
